<template>
  <v-main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" xs="3">
          <v-img src="../../assets/images/layout/logo-instituto-prohemoce-iph.png"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'LoginLogo',
}
</script>
